import { BorrowerNaturalPersonDto } from 'api/borrower';
import { ReferentialKey } from 'api/referential';
import { ReferentialDto } from 'api/risk';
import { BorrowerNaturalFormValues } from 'features/subscription-process/profiling-process/forms/borrower-insured';
import { mapNaturalPerson } from './mapNaturalPerson';

export function mapBorrowerNaturalPerson(
  entity: BorrowerNaturalPersonDto,
  referentialsData: Record<ReferentialKey, ReferentialDto[]>,
): BorrowerNaturalFormValues {
  const { job, prospectTypeId, ...naturalPerson } = entity

  const getReferentialCode = (referentialKey: ReferentialKey, id?: string | null) => {
    const referential = referentialsData[referentialKey].find((item: any) => item.id === id);
    return referential ? (referential.code as string) : undefined;
  };

  const mappedNaturalPerson = mapNaturalPerson(naturalPerson, referentialsData)

  return {
    ...mappedNaturalPerson,
    job,
    prospectType: getReferentialCode(ReferentialKey.ProspectType, prospectTypeId) || '',
    borrowerId: entity.borrowerId
  };
}
